import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5OutlinedSvg from "@ant-design/icons-svg/es/asn/Html5Outlined";
import AntdIcon from '../components/AntdIcon';
var Html5Outlined = function Html5Outlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: Html5OutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(Html5Outlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'Html5Outlined';
}
export default RefIcon;